import { render, staticRenderFns } from "./text-row-single-document.vue?vue&type=template&id=9cd17344&scoped=true&"
import script from "./text-row-single-document.vue?vue&type=script&lang=js&"
export * from "./text-row-single-document.vue?vue&type=script&lang=js&"
import style0 from "./text-row-single-document.vue?vue&type=style&index=0&id=9cd17344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd17344",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9cd17344')) {
      api.createRecord('9cd17344', component.options)
    } else {
      api.reload('9cd17344', component.options)
    }
    module.hot.accept("./text-row-single-document.vue?vue&type=template&id=9cd17344&scoped=true&", function () {
      api.rerender('9cd17344', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/text-row-single-document.vue"
export default component.exports